<template>
  <div class="bannerList">
    <div v-if="bannerList.length" :class="{'isHomeBanner':queryId=='Home_Banner'}">
      <swiper :options="swiperOption">
        <swiper-slide v-for="item in bannerList" :key="item.path">
          <img class="banner" :src="item.LinkUrl" @click="openBanner(JSON.stringify(item))">
        </swiper-slide>
        <div v-if="queryId=='Home_Banner'" class="swiper-pagination Home_Banner" :class="{'isIos': orderSource==17}" slot="pagination"></div>
      </swiper>
    </div>

<!--    <swiper :options="swiperOption">-->
<!--      <swiper-slide v-for="item in aaa" :key="item">-->
<!--        <div style="width: 100%; height: 400px; text-align: center;font-size: 36px; line-height: 400px;">{{ item }}</div>-->
<!--      </swiper-slide>-->
<!--      <div class="swiper-pagination Home_Banner" :class="{'isIos': orderSource==17}" slot="pagination"></div>-->
<!--    </swiper>-->
  </div>
</template>

<script>
/*组件方式引用*/
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { orderSource, resourceUrl } from "@/utils/env";
export default {
  name: 'banner',
  components: { swiper,swiperSlide },
  data(){
    return {
      aaa: [1,2,3,4,5,6,7,8,9],
      resourceUrl: resourceUrl,
      orderSource: orderSource,
      swiperOption: { // swiper3 组件
        pagination: {el: '.swiper-pagination'},
        autoplay: { delay: 3000 },
        stopOnLastSlide: false,
        disableOnInteraction: false,
        autoplayDisableOnInteraction: false,
        speed: 600,
        loop: false,
      }
    }
  },
  props: {
    bannerList: {
      default: []
    },
    queryId: {
      default: ''
    }
  },
  watch: {
    swiperOption (val) {
      console.log(val)
    }
  },
  created () {this.initData();},
  mounted () {},
  methods: {
    async initData(){
      // console.log(this.queryId)
      if( this.queryId=='Banner' ){
        this.swiperOption.autoplay = false;
      }
    },
    openBanner(en) {
      if( typeof en == 'object' ){ return; }
      let item = null;
      if( typeof en == 'string' ){ item = JSON.parse(en) }
      let openType = '';
      if( item.LandingPage.indexOf('https://')!=-1 || item.LandingPage.indexOf('http://')!=-1 ){
        openType = 'html'
      } else {
        openType = 'app'
      }
      if( orderSource==16 ){
        dfpanda.openPage(JSON.stringify({type: openType, url: item.LandingPage}))
      } else if( orderSource==17 ) {
        window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: openType, url: item.LandingPage}));
      }
    },
  }
}
</script>
<style lang="scss">
.bannerList .swiper-container-horizontal > .Home_Banner.swiper-pagination-bullets {
  width: 100%;
  /*bottom: 345px;*/
  height: 20px;
  text-align: center;
  top: 330px;
}
.bannerList .swiper-container-horizontal > .isIos.swiper-pagination-bullets {
  top: 290px !important;
}
.bannerList .swiper-container-horizontal > .Home_Banner.swiper-pagination-bullets .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 0.5;
  border-radius: 8px;
}
.bannerList .swiper-container-horizontal > .Home_Banner.swiper-pagination-bullets .swiper-pagination-bullet-active {
  width: 16px;
  opacity: 1;
}
</style>
<style lang="scss" scoped>
.bannerList {
  width: 100%;
  .isHomeBanner {
    height: 690px;
    overflow: hidden;
  }
  .banner {
    width: 100%;
  }
}
</style>